import { RootState } from "@base/store";
import Button from "@components/atoms/button";
import Divider from "@components/atoms/divider";
import { AddToCalendarButton } from "@components/molecules/add-to-calendar-button";
import { StripePaymentModal } from "@components/molecules/stripe-modal";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";
import MuiButton from "@mui/material/Button";
import Link from "@mui/material/Link";
import dayjs from "dayjs";
import { ReactElement, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { EventProps } from "../add-to-calendar-button/addToCalendarButton.molecule";
import {
  ActionWrapper,
  AddToCalendarBtnWrapper,
  BtnWrapper,
  CardTexts,
  CardTitle,
  Container,
  Content,
  CurrencyWrapper,
  DetailFooterWrapper,
  EditIconWrapper,
  FeesAndCurrencyWrapper,
  FeesInfoWrapper,
  Footer,
  FooterWrapper,
  GameDetailTypography,
  Header,
  IconWrapper,
  Info,
  InfoCardButton,
  InfoWrapper,
  ShareIconWrapper,
  TitleWrapper,
} from "./gameDetailsCard.styled";
import { ComponentProps } from "./gameDetailsCard.type";

import { ReactComponent as Calendar } from "@assets/images/calender/calendar.svg";
import { ReactComponent as Cash } from "@assets/images/cash/BsCash.svg";
import { ReactComponent as Chat } from "@assets/images/chat/chat-bubble-left-ellipsis.svg";
import { ReactComponent as ChevronDown } from "@assets/images/chevrons/chevron-down.svg";
import { ReactComponent as ChevronUp } from "@assets/images/chevrons/chevron-up.svg";
import { ReactComponent as Control } from "@assets/images/control/control.svg";
import { ReactComponent as USD } from "@assets/images/currencies/BsCurrencyDollar.svg";
import { ReactComponent as EUR } from "@assets/images/currencies/BsCurrencyEuro.svg";
import { ReactComponent as GBP } from "@assets/images/currencies/BsCurrencyPound.svg";
import { ReactComponent as AED } from "@assets/images/currencies/trade 1.svg";
import { ReactComponent as Pencil } from "@assets/images/edit/pencil.svg";
import { ReactComponent as PinMap } from "@assets/images/pin-map/map-pin.svg";
import { ReactComponent as Share } from "@assets/images/share/share.svg";
import { ReactComponent as Check } from "@assets/images/status-icons/check.svg";
import { ReactComponent as WhiteCheck } from "@assets/images/status-icons/white-check.svg";
import { ReactComponent as Cross } from "@assets/images/status-icons/x-mark.svg";
import { ReactComponent as WhiteCross } from "@assets/images/status-icons/x-white-mark.svg";

const GameDetailsCard = ({
  date,
  fee,
  location,
  title,
  isAttending,
  info,
  link,
  currentPlayersQty,
  maxPlayers,
  isCash,
  isOnlineTransfer,
  isAvailableOnMarketplace,
  isOnlinePayment,
  endDate,
  addressCoordinate,
  handleLeaveWaitList,
  startDate,
  setSharedGameId,
  currency,
  handleEdit,
  gameStatus,
  handleRSVP,
  handelShare,
  hasStripeAccount,
  isUserASub,
  isOrganizer,
  paymentStatus,
  selectedGame,
  intentId,
}: ComponentProps) => {
  const navigate = useNavigate();
  const [isExpanded, setExpanded] = useState<boolean>(false);
  const userId = useSelector((state: RootState) => state.user.user.uuid);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [openPaymentModal, setOpenPaymentModal] = useState<boolean>(false);
  const isToJoinAsSub = maxPlayers === currentPlayersQty && !isAttending;
  const [waitListDialogOpen, setWaitListDialogOpen] = useState(false);

  const game_details = {
    date: date,
    fee: fee,
    location: location,
    title: title,
    info: info,
    startDate: startDate,
    currency: currency,
    selectedGame: selectedGame,
    addressCoordinate: addressCoordinate,
  };
  const handleClickWaitListDialogOpen = () => {
    setWaitListDialogOpen(true);
  };

  const handleCloseWaitListDialogOpen = () => {
    setWaitListDialogOpen(false);
  };

  // console.log("isAttending", isAttending);
  // console.log("paymentStatus", paymentStatus);

  function shortenUrlToLength(originalUrl: string, length: number) {
    if (originalUrl.length <= length) {
      return originalUrl;
    }

    // Extract the protocol and domain
    const url = new URL(originalUrl);
    const protocolDomain = url.protocol + "//" + url.host;

    // Calculate the available space for the path and query
    const availableSpace = length - protocolDomain.length - 3; // 3 for "..."

    // Get the path and query
    let pathQuery = url.pathname + url.search;

    // Shorten the path and query if necessary
    if (pathQuery.length > availableSpace) {
      pathQuery = pathQuery.slice(0, availableSpace) + "...";
    }

    // Reconstruct the shortened URL
    const shortenedUrl = protocolDomain + pathQuery;

    return shortenedUrl;
  }

  const InfoRender = (
    icon: ReactElement,
    title?: string | number,
    isLink?: boolean,
    link?: string
  ) => {
    return (
      <Info>
        <Box>{icon}</Box>
        {isLink ? (
          <Link
            sx={{ wordWrap: "break-word", cursor: "pointer" }}
            onClick={() => {
              window.open(link, "_blank");
            }}
          >
            {shortenUrlToLength(link!, 30)}
          </Link>
        ) : (
          <Typography
            sx={{
              wordWrap: "break-word",
              fontFamily: "NotoSans-Medium",
              fontSize: "14px",
            }}
          >
            {title}
          </Typography>
        )}
      </Info>
    );
  };

  const mapInfoRender = (
    icon: ReactElement,
    title?: string | number,
    isLink?: boolean,
    link?: string
  ) => {
    return (
      <Info>
        <Box>{icon}</Box>
        {isLink ? (
          <Link
            sx={{ wordWrap: "break-word", cursor: "pointer" }}
            onClick={() => {
              window.open(link, "_blank");
            }}
          >
            {title}
          </Link>
        ) : (
          <Typography
            sx={{
              wordWrap: "break-word",
              fontFamily: "NotoSans-Medium",
              fontSize: "14px",
            }}
          >
            {title}
          </Typography>
        )}
      </Info>
    );
  };

  const CurrencyPriceRender = (icon: ReactElement, title: string | number) => {
    return (
      <Info>
        <Box>{icon}</Box>
        <CurrencyWrapper isPound={currency === "GBP"}>
          <Typography sx={{ wordWrap: "break-word" }}>{title}</Typography>
          {currencyRender(currency)}
        </CurrencyWrapper>
      </Info>
    );
  };

  const currencyRender = (currency: string) => {
    switch (currency) {
      case "USD":
        return <USD width={15} height={15} />;
      case "AED":
        return <AED width={15} height={15} />;
      case "GBP":
        return <GBP width={15} height={15} />;
      case "EUR":
        return <EUR width={15} height={15} />;
      default:
        break;
    }
  };

  const getDate = (date: string) => {
    return new Date(date).toISOString().slice(0, 10);
  };

  const getTime = (d: string) => {
    const date = new Date(d).toISOString();
    const timeObject = dayjs(date);
    const formattedTime = timeObject.format("HH:mm");
    return formattedTime;
  };

  const handleFooterClick = () => {
    setExpanded(!isExpanded);
  };

  const event: EventProps = {
    title: title,
    description: info,
    location: location,
    start: getDate(startDate!),
    end: getDate(endDate!),
    startTime: getTime(startDate!),
    endTime: getTime(endDate!),
  };

  const handleConfirmClick = () => {
    if (handleLeaveWaitList) {
      handleLeaveWaitList();
    }
    handleCloseWaitListDialogOpen();
  };

  const handlePayNow = () => {
    setOpenPaymentModal(true);
  };

  const PlayerView = () => {
    return (
      <>
        {isAttending && paymentStatus && (
          <Button
            textColor={""}
            color="neutral"
            text={"View Transaction"}
            type={"button"}
            onClick={() => navigate(`/transaction/${intentId}`)}
          />
        )}
        {!isAttending && paymentStatus && (
          <Button
            textColor={""}
            color="neutral"
            text={"View Transaction"}
            type={"button"}
            onClick={() => navigate(`/transaction/${intentId}`)}
          />
        )}
        {isAttending && !paymentStatus && (
          <Button
            textColor={""}
            color="neutral"
            text={"Pay now"}
            type={"button"}
            onClick={handlePayNow}
          />
        )}
        {openPaymentModal && (
          <StripePaymentModal
            game_details={game_details}
            handleClose={() => {
              setOpenPaymentModal(false);
            }}
            isOpen={openPaymentModal}
          />
        )}
      </>
    );
  };

  const OrganizerView = () => {
    return (
      <Button
        textColor={""}
        color="neutral"
        text={"View Transactions"}
        type={"button"}
        onClick={() => navigate(`/settings/transactions?txn_type=IN`)}
      />
    );
  };

  return (
    <Container>
      <Header>
        {userId && (
          <AddToCalendarBtnWrapper>
            <AddToCalendarButton event={event} />
          </AddToCalendarBtnWrapper>
        )}
        <TitleWrapper>
          <CardTitle>{title}</CardTitle>
        </TitleWrapper>
        {handleEdit && (
          <EditIconWrapper onClick={handleEdit}>
            <Pencil />
          </EditIconWrapper>
        )}
        <ShareIconWrapper
          onClick={() => {
            gameStatus === "upcoming" && handelShare();
          }}
        >
          <Share />
        </ShareIconWrapper>
      </Header>
      <Content>
        {InfoRender(<Calendar />, date)}
        {mapInfoRender(
          <PinMap />,
          location,
          !!addressCoordinate?.latitude,
          `https://www.google.com/maps?q=${addressCoordinate?.latitude},${addressCoordinate?.longitude}`
        )}
        <FeesInfoWrapper>
          <FeesAndCurrencyWrapper>
            {CurrencyPriceRender(<Cash />, fee)}
          </FeesAndCurrencyWrapper>
          {isCash && InfoRender(<Control />, "Cash")}
          {isOnlinePayment && InfoRender(<Control />, "In-App Payment")}
          {isOnlineTransfer && InfoRender(<Control />, "Bank Transfer")}
        </FeesInfoWrapper>
        {isAvailableOnMarketplace && InfoRender(<Control />, "Available on marketplace")}
        {isOpen && (
          <Alert severity="warning">
            You need to login In order to join the game{" "}
          </Alert>
        )}
        {isToJoinAsSub && !isUserASub && !isOpen && (
          <Alert severity="warning">
            This game is at full capacity at the moment. Click "IN" to join the
            waitlist.
          </Alert>
        )}
        {isToJoinAsSub && isUserASub && (
          <>
            <Alert
              sx={{
                "& .MuiAlert-message": {
                  width: "100%",
                },
              }}
              severity="success"
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>You're on the waitlist</div>
                <ExitToAppIcon
                  onClick={handleClickWaitListDialogOpen}
                  sx={{ cursor: "pointer" }}
                  color="action"
                />
              </Box>
            </Alert>
            <Dialog
              open={waitListDialogOpen}
              onClose={handleCloseWaitListDialogOpen}
            >
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to leave the waitlist ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseWaitListDialogOpen}
                  textColor={"#FFF"}
                  text={"Cancel"}
                  type={"button"}
                  color="error"
                />
                <Button
                  textColor={"#FFF"}
                  text={"Confirm"}
                  type={"button"}
                  onClick={handleConfirmClick}
                />
              </DialogActions>
            </Dialog>
          </>
        )}
        {!isUserASub && (
          <>
            {!isOpen ? (
              <>
                {userId ? (
                  <ActionWrapper>
                    <InfoCardButton
                      variant={isAttending ? "contained" : "outlined"}
                      customtextcolor={isAttending ? "#FFF" : "#129479"}
                      startIcon={!isAttending ? <Check /> : <WhiteCheck />}
                      onClick={isAttending ? undefined : () => handleRSVP("A")}
                    >
                      IN
                    </InfoCardButton>
                    <InfoCardButton
                      variant={!isAttending ? "contained" : "outlined"}
                      customtextcolor={!isAttending ? "#FFF" : "#129479"}
                      startIcon={isAttending ? <Cross /> : <WhiteCross />}
                      onClick={isAttending ? () => handleRSVP("N") : undefined}
                    >
                      OUT
                    </InfoCardButton>
                  </ActionWrapper>
                ) : (
                  <ActionWrapper>
                    <BtnWrapper onClick={() => setIsOpen(true)}>
                      <InfoCardButton
                        disabled
                        variant={"contained"}
                        startIcon={<WhiteCheck />}
                        onClick={() => setIsOpen(true)}
                      >
                        IN
                      </InfoCardButton>
                    </BtnWrapper>
                    <BtnWrapper onClick={() => setIsOpen(true)}>
                      <InfoCardButton
                        disabled
                        variant={"contained"}
                        startIcon={<WhiteCross />}
                        onClick={() => setIsOpen(true)}
                      >
                        OUT
                      </InfoCardButton>
                    </BtnWrapper>
                  </ActionWrapper>
                )}
              </>
            ) : (
              <MuiButton
                color="primary"
                variant={"contained"}
                sx={{ color: "#FFF" }}
                onClick={() => {
                  setSharedGameId && setSharedGameId();
                  navigate("/");
                }}
              >
                LogIn
              </MuiButton>
            )}
          </>
        )}
        {!isOrganizer && isOnlinePayment && <PlayerView />}
        {isOrganizer && isOnlinePayment && <OrganizerView />}
        <Footer>
          {isExpanded ? (
            <>
              {!!info || !!link ? (
                <DetailFooterWrapper>
                  <InfoWrapper>
                    {link && InfoRender(<Chat />, title.toString(), true, link)}
                    {info && <CardTexts>{info}</CardTexts>}
                  </InfoWrapper>
                  <br />
                  <IconWrapper>
                    <ChevronUp onClick={handleFooterClick} />
                  </IconWrapper>
                </DetailFooterWrapper>
              ) : (
                <DetailFooterWrapper onClick={handleFooterClick}>
                  <InfoWrapper>
                    {<Typography>No Extra Information!</Typography>}
                  </InfoWrapper>
                  <br />
                  <IconWrapper>
                    <ChevronUp />
                  </IconWrapper>
                </DetailFooterWrapper>
              )}
            </>
          ) : (
            <>
              <Divider orientation="horizontal" />
              <FooterWrapper onClick={handleFooterClick}>
                <GameDetailTypography>{"Game details"}</GameDetailTypography>
                <IconWrapper>
                  <ChevronDown />
                </IconWrapper>
              </FooterWrapper>
            </>
          )}
        </Footer>
      </Content>
    </Container>
  );
};

export default GameDetailsCard;
